import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { useBrandedAppsFeatureFlags } from "@/react/hooks/useBrandedAppsFeatureFlags";

export const useIsPlusCommandCenterEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { brandedAppsBuilder } = useBrandedAppsFeatureFlags();

  return (
    brandedAppsBuilder.isEnabled &&
    Boolean(currentCommunitySettings?.plus_command_center_enabled)
  );
};
